import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
/**
 * put 0 when load
 */
@Pipe({
  name: "zeroIni",
  pure: false,
})
export class zeroInitPipe implements PipeTransform {
  /**
   * Constructor
   */
  constructor() { }
  /**
   * Transform
   * @input
   * @args
   */
  transform(input: any, args?: any): any {
    if (Number.isNaN(input) || input === undefined) {
      return 0;
    } else {
      return input;
    }
  }
}
/**
 * thousand Suffix
 */
@Pipe({
  name: "currencyToNumber",
  pure: false,
})
export class currencyToNumberPipe implements PipeTransform {
  /**
   * Constructor
   */
  constructor() { }
  /**
   * Transform
   * @input
   * @args
   */
  transform(input: any, args?: any): any {
    if (Number.isNaN(input) || input === undefined) {
      return 0;
    } else {
      return Number(input.replace(/[^0-9.-]+/g, ""));
    }
  }
}
/**
 * first mayus
 */
@Pipe({
  name: "firstMayus",
  pure: false,
})
export class firstMayusPipe implements PipeTransform {
  /**
   * Constructor
   */
  constructor() { }
  /**
   * Transform any text with first letter in Mayus
   * @input
   * @args
   */
  transform(input: string, args?: any): any {

    if (typeof input !== 'string') { return input; }
    return input
      .toLowerCase()
      .replace(/(^|\.{3}\s+|\.\s+|:\s+)(\w)/g, (match, separator, letter) => {
        return separator + letter.toUpperCase();
      });
      
  }
}

/**
 * first M
 */
@Pipe({
  name: "firstMinus",
  pure: false,
})
export class firstMinusPipe implements PipeTransform {
  /**
   * Constructor
   */
  constructor() { }
  /**
   * Transform any text with first letter in Minus
   * @input
   * @args
   */
  transform(input: any, args?: any): any {
    let first = (typeof input == 'string') ? input.substr(0, 1).toLocaleLowerCase() : '';
    return (typeof input == 'string') ? first + input.substr(1).toLocaleLowerCase() : input;
  }
}

const padding = "000000";
@Pipe({
  name: "mxcurrency",
  pure: false,
})
export class MXCurrencyPipe implements PipeTransform {
  private prefix: string;
  private decimal_separator: string;
  private thousands_separator: string;
  private suffix: string;

  constructor() {
    this.prefix = "$";
    this.suffix = " ";
    this.decimal_separator = ".";
    this.thousands_separator = ",";
  }

  transform(
    value: any,
    fractionSize: number = 0,
    suffix: string = this.suffix
  ): string {
    fractionSize = (parseFloat(value) % 1 != 0) ? fractionSize : 2;

    let [integer, fraction = ""] = (parseFloat(value).toString() || "")
      .toString()
      .split(".");

    fraction =
      fractionSize > 0
        ? this.decimal_separator +
        (fraction + padding).substring(0, fractionSize)
        : "";

    integer = integer.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      this.thousands_separator
    );

    let transnform = (input: any) => {
      let first = (typeof input == 'string') ? input.substr(0, 1).toUpperCase() : '';
      return (typeof input == 'string') ? first + input.substr(1).toLocaleLowerCase() : input;
    };


    if (isNaN(parseFloat(integer))) { return transnform(value); }
    else { return this.prefix + integer + fraction + " " + suffix; }

  }
  parse(
    value: string,
    fractionSize: number = 2,
    suffix: string = this.suffix
  ): string {

    let [integer, fraction = ""] = (value || "")
      .replace(this.prefix, "")
      .replace(suffix, "")
      .split(this.decimal_separator);

    integer = integer.replace(new RegExp(this.thousands_separator, "g"), "");

    fraction =
      parseInt(fraction, 10) > 0 && fractionSize > 0
        ? this.decimal_separator +
        (fraction + padding).substring(0, fractionSize)
        : "";

    return integer + fraction;

  }
}

/**
 * ![tagAmountMax]
 * resolve string "Ilimitado" 
 * or amount recieve
 */
@Pipe({ name: "tagAmountMax", pure: false })
export class tagAmountMaxPipe implements PipeTransform {
  constructor() { }
  transform(value: number): any {
    let tag = "Ilimitado";
    if (
      value === 0 ||
      value == null ||
      Number.isNaN(value) ||
      value === undefined
    ) {
      return tag;
    } else {
      return value;
    }
  }
}

@Pipe({ name: 'filter', pure: false })
export class filterPipe implements PipeTransform {
  transform(items: any[], field: string, value: string): any[] {
    if (!items) return [];
    if (!value || value == '0') return items;
    return items.filter(it =>
      it[field].toLowerCase().indexOf(value.toLowerCase()) != -1);
  }
}


/**
 * ![sentenceCase]
 * transform to first letter to Mayus 
 * in sentence o word
 */
@Pipe({ name: "sentenceCase", pure: false })
export class sentenceCasePipe implements PipeTransform {
  transform(value: string): any {
    let output = (value) ? value.trim() : '';
    output = output.charAt(0).toUpperCase() + output.toLowerCase().substring(1);
    return output;
  }
}


/**
 * ![maskTelephone]
 * transform to mask telephone
 * in telephone
 */
@Pipe({ name: "maskTelephone", pure: false })
export class maskTelephonePipe implements PipeTransform {
  transform(value: string): any {
    if (value) {
      let chars = value.length - 2;
      let x = '';
      for (let index = 0; index < chars; index++) { x += "*"; }
      let mask = x + value.toString().slice(-2);
      return mask;
    }
  }
}

/**
 * ![maskEmail]
 * transform to mask email
 * in email
 */
@Pipe({ name: "maskEmail", pure: false })
export class maskEmailPipe implements PipeTransform {
  transform(value: string): any {
    if (value) {
      let email = value.split('@');
      return email[0].substring(0, 2) + '**@' + email[1];
    }
  }
}


@Pipe({
  name: "safeHtml",
  pure: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}


@Pipe({
  name: "formattedLC",
  pure: false,
})
export class formattedLCPipe implements PipeTransform {
  /**
   * Constructor
   */
  constructor() { }

  transform(lineCapture: string): string {

    if (lineCapture) {

      let stringCln = lineCapture?.toUpperCase(),
        lengths = [8, 4, 1, 4, 4, 7, 7, 7, 7, 4],
        arrValPste = lengths.map((p => i => stringCln.slice(p, p += i))(0));

      return arrValPste.toString().replaceAll(',', ' - ')
    }
  }
}

@Pipe({
  name: "txtTruncate",
  pure: false
})
export class texTruncatePipe implements PipeTransform {

  transform(text: string, charLimit = 10) {
    if (!text || text.length <= charLimit) {
      return text;
    }

    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charLimit) + "...";
    return shortened;
  }
}


@Pipe({ name: "objLength", pure: false })
export class objLengthPipe implements PipeTransform {
  transform(object: any, ...args: any[]) {
    return Object.keys(object).length;
  }
}

@Pipe({
  name: 'moneyFormat',
  pure: true,
})
export class MoneyFormatPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value === null || value === undefined || value === '') return '';

    let numberValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numberValue)) return '';

    const parts = numberValue
      .toFixed(2) // fuerza 2 decimales siempre
      .toString()
      .split('.');

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return `$ ${parts.join('.')}`;
  }
}

@Pipe({
  name: 'mskContract',
  pure: true,
})
export class MaskContractPipe implements PipeTransform {
  transform(numContract: string): string {
    if (numContract)
      return `****** ${numContract.slice(-3)}`
  }
}
@Pipe({
  name: 'reduceString',
  pure: true,
})
export class ReduceStringPipe implements PipeTransform {
  transform(string: string, lengthToReduce: number): string {
    if (string && string.length > lengthToReduce) {
      return string.substring(0, (lengthToReduce - 3)) + '...'
    } else { return string}
    return '';
  }
}









